import React from 'react';
import { OutlinedButtonStyle, styles } from './OutlinedButton.styles';

function OutlinedButton(props) {
  const { button } = styles;
  return <OutlinedButtonStyle {...button} {...props} />;
}
export default OutlinedButton;
